import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomCommon } from '@shared/custom-common/custom-common';

@Component({
    selector: 'file-viewer',
    templateUrl: './file-viewer.component.html',
    styleUrls: ['./file-viewer.component.scss']
})
export class FileViewerComponent implements OnInit {
    @Input() fileUrl!: string;
    @Input() fileName!: string;
    @Input() showView = true;
    @Input() showDownload = true;
    isPdfFile = false;

    constructor(private http: HttpClient) {}

    ngOnInit(): void {
        if (this.fileUrl) {
            const fileExtension = this.fileUrl.split(CustomCommon.Dot).pop()?.toLowerCase();

            switch (fileExtension) {
                case CustomCommon.PDF:
                    this.isPdfFile = true;
                    break;
                // Add more cases for other file types if needed
                default:
                    this.isPdfFile = false;
            }
        }

        console.log('File name:', this.fileName);
    }

    //#region Pdf actions
    viewPdf(url?: string): void {
        const finalUrl = url || this.fileUrl;
        if (!finalUrl) {
            return;
        }
        window.open(finalUrl, '_blank', 'noopener,noreferrer');
    }

    downloadPdf(url?: string, fileName?: string): void {
        let finalUrl = url || this.fileUrl;
        let finalFileName = fileName || this.fileName || 'document.pdf';

        if (finalUrl) {
            finalUrl = '/api' + finalUrl.split('assets')[1];
        }

        if (!finalFileName.toLowerCase().endsWith(CustomCommon.PDF)) {
            finalFileName += this.formatDate(new Date()) + CustomCommon.DownloadFilePdf;
        }

        if (!finalUrl) {
            return;
        }
        this.http.get(finalUrl, { responseType: CustomCommon.Blob }).subscribe((resp: any) => {
            let blob = new Blob([resp], { type: CustomCommon.ApplicationPdf });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = finalFileName;
            link.click();
        });
    }
    //#endregion

    private formatDate(date: Date): string {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('');
    }
}
